var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroundgirl01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4e211;}.cls-2{fill:#fcea47;}.cls-3{fill:#ff715d;}.cls-4{fill:#f5f1e5;}.cls-5{fill:#2ca0ff;}.cls-6{clip-path:url(#clip-path);}.cls-7{fill:#2c2e2a;}.cls-8{clip-path:url(#clip-path-2);}.cls-18,.cls-9{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;}.cls-9{stroke-width:3px;}.cls-10{clip-path:url(#clip-path-3);}.cls-11{fill:#ebc2ff;}.cls-12{clip-path:url(#clip-path-4);}.cls-13{clip-path:url(#clip-path-5);}.cls-14{clip-path:url(#clip-path-6);}.cls-15{clip-path:url(#clip-path-7);}.cls-16{clip-path:url(#clip-path-8);}.cls-17{clip-path:url(#clip-path-9);}.cls-18{stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.55,752.4s62.35-365.13,271-469.3c0,0,152.89-71.67,325.84,8.42l149.74-37.92s210.46,227.78,267,394c0,0-169.47,17.42-340.1,158.57Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556.2,312.42s125.36-128.85,314.57-159c0,0,159,3.49,279.74,124.2,0,0-121.36-7-175.28,62.68C975.23,340.27,819.69,189.38,556.2,312.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M703.22,624.36s62.26-78,161.77-74.7c0,0,29.41,89.32,17.88,245.82,0,0-89.47,22.57-165.23-4.05h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.08,631.29c19-14.13,55.09-42.58,74.73-68.78a20.21,20.21,0,0,1,20.26-7.68l27.44,5.71s53.66,111,66.13,196a16.55,16.55,0,0,1-4.88,14.34l-73.82,71.32a17.09,17.09,0,0,1-18.81,3.32L160.76,840a19.56,19.56,0,0,1-10.19-10.53c-11.85-29.24-56.09-138-74-176.07A18,18,0,0,1,82.08,631.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.59,555.89l-100.91,81A21.5,21.5,0,0,0,103.75,663c18,37.46,63.91,134.95,84.46,195.08l98.66-93S232.36,577.66,210.59,555.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.16,658.25l52.63,116.88a8.75,8.75,0,0,0,12.94,3.61l65.24-45a8.74,8.74,0,0,0,3.48-9.51c-5.34-19.41-23.46-82-47.84-129.67a8.75,8.75,0,0,0-13.21-2.84l-70.69,56.08A8.75,8.75,0,0,0,119.16,658.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251,757.73c-11.22-2.91-44.13-13.24-59.86-37.23,0,0-36.38-69.36-44.17-4.69A341.68,341.68,0,0,0,150.78,765a28.56,28.56,0,0,1-6.17-.11,37,37,0,0,1-29.81-22.61l-14-33.38s-41.79,18-10.29,72.57c0,0-31.47,11.19,15.29,61.17,0,0-15.71,71.94,115.47,58.34,0,0,38.32-6.27,60.5-49a64.58,64.58,0,0,0,3.29-51.77c-4.9-13.44-13-29.12-25.67-38.61A24.14,24.14,0,0,0,251,757.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 384.97,
    cy: 572.25,
    r: 87.93
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 472.9,
    cy: 549.66,
    r: 16.26
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ground girl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tent"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.55,752.4s62.35-365.13,271-469.3c0,0,152.89-71.67,325.84,8.42l149.74-37.92s210.46,227.78,267,394c0,0-169.47,17.42-340.1,158.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M433,767.82s47.28-298,236.4-390.11c48.47-23.6,106.68-14.84,145.06,23,51.26,50.58,100.83,162.12,82.31,407.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.83,774.67s32.57-271.34,201.32-364c58.61-32.19,132.5-14.44,169.44,41.29s67.08,159.34,58.28,350.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1016.73,543.94s34.82,179.09,28.73,308.8h12.19s-6.22-219.9-32.37-309.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1258.75,428.55s111.43,154.32,131.45,246.6l10.45-9.25s-48.75-135.26-133.2-241.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297,758.65S373.78,520.05,460,440.17l7.7,4.44s-92.8,113.26-158.56,314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M941.57,303.39s50.67,117.4,58.34,237.42a15.09,15.09,0,0,0,19.84,13.38l1.52-.51a15.07,15.07,0,0,0,10.12-16.61c-6.15-39.7-27.09-163.78-58.48-233.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1114.54,281.15c29.53,29.94,100.61,103.53,137.21,154.47a10.56,10.56,0,0,0,15,2.2l4.33-3.35a10.56,10.56,0,0,0,2.36-14.15c-17.89-27.22-78.78-114.91-145.91-155.59a10.62,10.62,0,0,0-7.88-1.28h0A10.56,10.56,0,0,0,1114.54,281.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M450.86,444.61l22,10.15s81.53-110.42,161.65-180.94C634.55,273.82,525.61,315.13,450.86,444.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556.2,312.42s125.36-128.85,314.57-159c0,0,159,3.49,279.74,124.2,0,0-121.36-7-175.28,62.68C975.23,340.27,819.69,189.38,556.2,312.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M891.66,168.48s62,31.26,83.57,171.79"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M703.22,624.36s62.26-78,161.77-74.7c0,0,29.41,89.32,17.88,245.82,0,0-89.47,22.57-165.23-4.05h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M793.14,772.08s48.61-4.12,54.11-56"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M684,273.82s129.81-38.23,252.71,38.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1037.19,298.44s53.13-25.78,113.32-20.85"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hair_buns",
    "data-name": "hair buns"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 418.11,
    cy: 483.21,
    r: 25.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.69,
    cy: 428.55,
    r: 36.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.89,
    cy: 349.04,
    r: 50.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M433,605.53s70.42-87.83,227.57-1.23c0,0,36.71-8.11,53.18,8.36,0,0,37.38,72.2,3.92,178.77,0,0-141.12,79.73-250,16.88C467.68,808.31,420.29,693.48,433,605.53Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "upper_hand",
    "data-name": "upper hand"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 450.3,
    cy: 774.44,
    rx: 171.44,
    ry: 84.05,
    transform: "translate(-416.6 1000.29) rotate(-74.43)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "lower_hand",
    "data-name": "lower hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M270.13,753.12s65.49,14.7,112.23,14.7c36.39,4.52,66.95,28.54,78.08,61.54,12.82,38,.53,83.46-34.3,108.15a28,28,0,0,1-10.42,4.58,187.9,187.9,0,0,1-47,3.2c-31.58-1.8-76.93-13.41-132-52.61C236.72,892.68,199,800.4,270.13,753.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M366.13,769.33s27.57,12.84,27.57,45.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M520.94,828.29s24.56-44.74,24.56-90.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M660.54,604.3a47.07,47.07,0,0,1,9.24,38.46"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.08,631.29c19-14.13,55.09-42.58,74.73-68.78a20.21,20.21,0,0,1,20.26-7.68l27.44,5.71s53.66,111,66.13,196a16.55,16.55,0,0,1-4.88,14.34l-73.82,71.32a17.09,17.09,0,0,1-18.81,3.32L160.76,840a19.56,19.56,0,0,1-10.19-10.53c-11.85-29.24-56.09-138-74-176.07A18,18,0,0,1,82.08,631.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.59,555.89l-100.91,81A21.5,21.5,0,0,0,103.75,663c18,37.46,63.91,134.95,84.46,195.08l98.66-93S232.36,577.66,210.59,555.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.16,658.25l52.63,116.88a8.75,8.75,0,0,0,12.94,3.61l65.24-45a8.74,8.74,0,0,0,3.48-9.51c-5.34-19.41-23.46-82-47.84-129.67a8.75,8.75,0,0,0-13.21-2.84l-70.69,56.08A8.75,8.75,0,0,0,119.16,658.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.83,660.86l43-33.8a5,5,0,0,1,7.42,1.43h0A5,5,0,0,1,194,634.9L151.21,669a5,5,0,0,1-7.13-.94l-.18-.26A5,5,0,0,1,144.83,660.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172,673l43-33.8a5,5,0,0,1,7.41,1.43h0a5,5,0,0,1-1.22,6.41L178.38,681.1a5,5,0,0,1-7.13-.94l-.18-.25A5,5,0,0,1,172,673Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.85,703.74l43-33.8a5,5,0,0,1,7.41,1.43h0a5,5,0,0,1-1.21,6.4l-42.84,34.06a5,5,0,0,1-7.12-1l-.19-.25A5,5,0,0,1,170.85,703.74Z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251,757.73c-11.22-2.91-44.13-13.24-59.86-37.23,0,0-36.38-69.36-44.17-4.69A341.68,341.68,0,0,0,150.78,765a28.56,28.56,0,0,1-6.17-.11,37,37,0,0,1-29.81-22.61l-14-33.38s-41.79,18-10.29,72.57c0,0-31.47,11.19,15.29,61.17,0,0-15.71,71.94,115.47,58.34,0,0,38.32-6.27,60.5-49a64.58,64.58,0,0,0,3.29-51.77c-4.9-13.44-13-29.12-25.67-38.61A24.14,24.14,0,0,0,251,757.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.55,781.51s22.17,27,64.82,27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M105.84,842.68s11,17.17,55.81,13.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M155.23,798.45s5.11,10.28,2.45,19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M162.34,847.89s4.81,10.78,0,19.12"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 384.97,
    cy: 572.25,
    r: 87.93
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315,528.43c8,4,17.88.8,25.15-4.41s13-12.31,20.31-17.52,17.14-8.34,25.15-4.36c6.14,3.05,9.71,9.46,13.61,15.11s9.38,11.28,16.24,11.24c4.17,0,8-2.19,11.91-3.54s8.83-1.73,11.8,1.18c3.42,3.35,2.49,9,1.48,13.63s-1.41,10.51,2.48,13.29c3.74,2.68,9.06.63,12.58-2.34,12.35-10.43,13.43-30.28,5.53-44.39s-22.74-23.09-38.06-28.24A117.55,117.55,0,0,0,361.36,475c-16.73,3.59-44.89,12.65-54.49,28.28C302,511.17,307,524.45,315,528.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M340.93,579.65s-2.83,34.4,15.49,29.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M381,596s4.73,12-8.62,18.37"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 386.81,
    cy: 578.89,
    r: 5.77
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_1",
    "data-name": "eyebrow 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.93,
    cy: 550.57,
    rx: 13.83,
    ry: 6.94,
    transform: "translate(-194.95 169.19) rotate(-23.63)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_2",
    "data-name": "eyebrow 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.68,
    cy: 545.47,
    rx: 6.29,
    ry: 12.86,
    transform: "translate(-255.75 754.17) rotate(-74.43)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "eye_1",
    "data-name": "eye 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.82,
    cy: 577.75,
    rx: 3.76,
    ry: 6.61
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layeeye2r_16",
    "data-name": "Layeeye2r 16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.13,
    cy: 573.88,
    rx: 3.39,
    ry: 5.77
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "ear"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 472.9,
    cy: 549.66,
    r: 16.26
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M464.55,547.6s8.35-7.6,17.2-2.13"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 107.43,
    y1: 639.01,
    x2: 188.19,
    y2: 573.88
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundgirl01);
export default __webpack_public_path__ + "static/media/ground girl-01.c05d26a6048bd200688a4c732fc8f7ba.svg";
export { ForwardRef as ReactComponent };